import {Injectable, inject} from '@angular/core'
import {ExtensionNetworkMode, ExtensionsConfiguration, UvePlatform} from '@models/extensionsConfiguration'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {ExtensionsService} from './extensions.service'

/**
 * Variante embebida del motor de extensiones.
 *
 * @description
 * En modo embebido las extensiones vienen en el payload (`configAgent.extensionsConfiguration`)
 * y no se cachean tablas adicionales localmente. Además, el contexto reporta
 * `networkMode: ONLINE` y `origin: BACKOFFICE`, para que las extensiones distingan el
 * caso "Street dentro de UVE Cloud" y puedan hacer asunciones distintas sobre conectividad.
 */
@Injectable({
  providedIn: 'root',
})
export class ExtensionsEmbeddedService extends ExtensionsService {
  private readonly embeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)
  protected override getExtensions = (): ExtensionsConfiguration[] =>
    this.embeddedStoreService.configAgent().extensionsConfiguration || []
  override clearCacheTablesInfo = async (): Promise<void> => {}
  override clearTablesCustomizationCache = (): void => {}
  protected getNetworkMode = (): ExtensionNetworkMode => ExtensionNetworkMode.ONLINE
  protected getOrigin = (): UvePlatform => UvePlatform.BACKOFFICE
}
